import { Navigate, NavLink, Route, Routes } from 'react-router';

import { Logo } from '@/components/brand/Logo';
import { BuildStamp } from '@/components/layout/BuildStamp';
import type { Operator } from '@/lib/api';
import { cn } from '@/lib/utils';

import { AnnouncementsPage } from './AnnouncementsPage';
import { TenantsPage } from './TenantsPage';

const NAV = [
  { to: '/tenants', label: 'テナント' },
  { to: '/announcements', label: 'お知らせ' },
] as const;

/**
 * 運営 (コントロールプレーン) のパネル。
 *
 * テナント向けダッシュボードと取り違えないよう、ヘッダーを濃色にして
 * 「CONTROL PLANE」を明示する。操作対象が全テナントなので、
 * 今どちらに居るかが一目で分かることを優先した。
 */
export function HqApp({ operator }: { operator: Operator }) {
  return (
    <div className="flex min-h-screen flex-col bg-surface">
      <header className="flex items-center justify-between bg-ink px-8 py-4 text-surface-raised">
        <div className="flex items-center gap-8">
          <Logo height={24} className="text-surface-raised" />
          <span className="font-mono text-[11px] tracking-widest text-ink-faint">
            CONTROL PLANE
          </span>
        </div>
        <div className="flex items-center gap-4">
          {/* 運営から「いま何が動いているか」が見える。SPA は Worker の
              assets として同時に出るので、ここに焼かれた値が本番の版数。 */}
          <BuildStamp className="text-ink-faint hover:text-surface-raised" />
          <span className="font-mono text-xs text-ink-faint">{operator.email}</span>
        </div>
      </header>

      <nav className="flex gap-1 border-b border-line bg-surface-raised px-8">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'border-b-2 px-4 py-3 text-sm',
                isActive
                  ? 'border-brand-700 text-ink'
                  : 'border-transparent text-ink-muted hover:text-ink',
              )
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <Routes>
        <Route index element={<Navigate to="/tenants" replace />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="announcements" element={<AnnouncementsPage />} />
        <Route path="*" element={<Navigate to="/tenants" replace />} />
      </Routes>
    </div>
  );
}
